import { CommonModule, DecimalPipe, registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentAuthModule } from '@pacifico/business/auth-flow/components/content-auth/content-auth.module';
import { LoginFormComponent } from '@pacifico/business/auth-flow/components/login-form/login-form.component';
import { AlertModule } from '@pacifico/components/alert/alert.module';
import { SharedFormModule } from '@pacifico/shared/shared-forms.module';
import { AuthPageComponent } from './auth-page.component';
import localeEsPe from '@angular/common/locales/es-PE';
import { RouterModule } from '@angular/router';
import { SharedComponentsModule } from '../../commons/shared/shared-components.module';
registerLocaleData(localeEsPe);
@NgModule({
	declarations: [AuthPageComponent, LoginFormComponent],
	imports: [CommonModule, SharedFormModule, AlertModule, ContentAuthModule, SharedComponentsModule, RouterModule],
	exports: [AuthPageComponent],
	providers: [DecimalPipe]
})
export class AuthPageModule {}
